import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { loginRequest, msalConfig } from './auth.config';
import { from, map, Observable, of, tap } from 'rxjs';
import {
  AuthenticationResult,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  initialized = false;

  private msalService: IPublicClientApplication | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      queueMicrotask(() => {
        this.msalService = new PublicClientApplication(msalConfig);
        this.initialized = true;
        console.log('MSAL instance created');
      });
    }
  }

  login(): Observable<AuthenticationResult> {
    return from(this.msalService!.loginPopup(loginRequest)).pipe(
      tap((result) => {
        this.msalService!.setActiveAccount(result.account);
      })
    );
  }

  init() {
    return from(this.msalService!.initialize());
  }

  logout() {
    return this.msalService!.logout();
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  isAuthenticated(): boolean {
    return Boolean(this.msalService) && this.msalService!.getAllAccounts().length > 0;
  }

  getActiveAccount() {
    return this.msalService!.getActiveAccount();
  }

  getAllAccounts() {
    return this.msalService!.getAllAccounts();
  }

  getAccessToken() {
    if (!isPlatformBrowser(this.platformId)) {
      return of(''); // or throw an error
    }

    return from(this.msalService!.acquireTokenSilent(loginRequest)).pipe(
      map((result) => result.accessToken)
    );
  }
}
